/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Bachelor8Inputs */

const en_job_form_enum_bachelor8 = /** @type {(inputs: Job_Form_Enum_Bachelor8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bachelor`)
};

const de_job_form_enum_bachelor8 = /** @type {(inputs: Job_Form_Enum_Bachelor8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bachelor`)
};

/**
* | output |
* | --- |
* | "Bachelor" |
*
* @param {Job_Form_Enum_Bachelor8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_bachelor8 = /** @type {((inputs?: Job_Form_Enum_Bachelor8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Bachelor8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_bachelor8(inputs)
	return en_job_form_enum_bachelor8(inputs)
});
export { job_form_enum_bachelor8 as "job_form_enum_BACHELOR" }